import type { FormikValues } from "formik";
import type { Context } from "react";
import { createContext, useContext } from "react";

import type { FormatMessage, FormatMessages, FormatStrings } from "@skilitics/localization";

import type { TestAttribute } from "./shared.ts";

export type FormContext<Values extends FormikValues = Record<string, undefined>> = TestAttribute & {
  submitOnBlur?: boolean;
  formatMessage?: FormatMessage<FormFormatMessages<Values>>;
  explicitLabels?: boolean;
  hasValidationSchema?: boolean;
};

export type FormFormatMessages<Values> = {
  [K in keyof Values & string as `${K}Label`]: FormatStrings;
} & {
  [K in keyof Values & string as `${K}Description`]?: FormatStrings;
} & {
  [K in keyof Values & string as `${K}Placeholder`]?: FormatStrings;
} & FormatMessages;

export const FormContext = createContext<FormContext>({});

export const useFormContext = <TValues extends FormikValues = Record<string, undefined>>() => {
  const context = useContext<FormContext<TValues>>(FormContext as Context<FormContext<TValues>>);
  return context ?? {};
};
